import { create } from "zustand";
import axios from 'axios';
import { store } from "../../../store";
import { persist } from 'zustand/middleware'
import { resolveServiceBase } from '../../../config/serviceBase';

const NEURODOC_GO_TEST = resolveServiceBase('/neurodoc-go-test')

interface PointProcent {
  getPoints: () => void,
  data: any,
  deleteData: () => void,
  dataChamp: any,
}

interface Spec {
  dataSpec: any,
  getDataSpec: (item: any) => void
  persist: any
}

interface Constructor {
  dataProcent: any,
  getDataProcent: (item: any) => void
}

export interface MenuItem {
  title: string;
  routePath: string;
  activateStage: number;
}

export interface MenuItemServ {
  routhPathCode: string;
  routePath: string;
  activeStage: number;
  code: string;
  legend_id: number;
  testingstage_descr: string;
  testingstage_id: number
}

interface MenuItemsStore {
  menuItems: MenuItem[] | null;
  final: boolean;
  setMenuItems: (items: any) => void;
  menuItemsServ: MenuItemServ[] | null;
  setMenuItemsServ: (items: any) => void;
  setFinal: (item: boolean) => void;
}


export const useMenuItemsStore = create<MenuItemsStore>((set) => ({
  menuItems: null,
  menuItemsServ: null,
  final: false,
  setMenuItemsServ: (items) => set({ menuItemsServ: items }),
  setMenuItems: (items) => set({ menuItems: items }),
  setFinal: (item: boolean) => set({ final: item })
}));

export const useSpec = create<any>(persist((set) => ({
  dataSpec: [],
  dataCheck: [],
  getDataSpec: (item: any) => set((state: any) => (
    {
      dataSpec: [
        ...state.dataSpec,
        item
      ]
    }
  )),
  getCheck: (item: any) => set((state: any) => (
    {
      dataCheck: [
        ...state.dataCheck,
        item
      ]
    }
  )),
  deleteDataSpec: () => set(() => (
    {
      dataSpec: []
    }
  )),
  deleteDataCheck: () => set(() => (
    {
      dataCheck: []
    }
  ))
}),
  {
    name: 'storageSpec',
    getStorage: () => localStorage,
  }
))

export const useConstructor = create<Constructor>((set) => ({
  dataProcent: null,
  getDataProcent: (item: any) => set(() => (
    {
      dataProcent: item
    }
  ))
})
)

export const usePointProcentStore = create<PointProcent>((set) => ({
  data: [],
  dataChamp: [],
  getChampionshipsAll:
    async () => {
      const jwtToken = store.getState().auth.jwtToken;
      await axios.post(
        `${NEURODOC_GO_TEST}/getAllChampionship`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + jwtToken,
          },
        }
      )
        .then(res => {
          const data = res.data.all_championship
          set({ dataChamp: data })
        })
        .catch(err => console.log(err))
    },
  deleteData: () => set(() => (
    {
      data: []
    }
  )),
  getPoints: async () => {
    const jwtToken = store.getState().auth.jwtToken;
    await axios.post(
      `${NEURODOC_GO_TEST}/getPoint`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + jwtToken,
        },
      }
    )
      .then(res => {
        const data = res.data.point
        set({ data: data })
      })
      .catch(err => console.log(err))
  }
}))
